import {GamesSliderWidgetGameViewModel} from "./games-slider-widget.game-view-model";
import {computed} from "mobx";
import {BaseModuleState} from "../../../infrastructure/models/base-module-state";
import {BaseMobxState} from "../../../infrastructure/mobx/base-mobx-state";
import {AppStore} from "../../../core/app/app-store";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {GamesSliderWidgetConfig} from "../games-slider-widget.config";
import {PartialGameDomainModel} from "../../../domain/partial-game/models/partial-game-domain-model";
import {ODDS_TYPES} from "../../../core/components/odds/components/odds-consts";
import {BookmakerViewModel} from "../../../domain/common/bookmaker/models/bookmaker-view-model";
import {BookmakerDomainModel} from "../../../domain/common/bookmaker/models/bookmaker-domain-model";
import {UserAgentViewModel} from "../../../core/models/user-agent.view-model";

export class GamesSliderWidgetState extends BaseModuleState {
  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, GamesSliderWidgetConfig, UserAgentViewModel];

  constructor(
    navigationManager: NavigationManager,
    appStore: AppStore,
    logger: LoggerUtils,
    datetimeUtils: DatetimeUtils,
    device: DeviceViewModel,
    termsUtils: TermsUtils,
    config: GamesSliderWidgetConfig,
    userAgent: UserAgentViewModel,
  ) {
    super(
      navigationManager,
      appStore,
      logger,
      datetimeUtils,
      device,
      termsUtils,
      config
    );

    this.userAgent = userAgent;
  }

  @computed get games(): Array<GamesSliderWidgetGameViewModel> {
    const games: Array<GamesSliderWidgetGameViewModel> = this.dataSource?.games?.map((game: PartialGameDomainModel) => {
      const date: String = this.datetimeUtils.toShortestDate(game.startTime);
      const time: String = this.datetimeUtils.toShortTime(game.startTime);
      const sliderGame: GamesSliderWidgetGameViewModel = new GamesSliderWidgetGameViewModel(game, date, time, this.oddsType, this.terms, this.datetimeUtils);

      return sliderGame;
    });

    return games;
  }

  @computed get oddsType(): ODDS_TYPES {
    return this.appState.currentOddsType;
  }

  get initialIndex(): Number {
    let initialIndex: Number = 0;

    if (this.device.isLargeView) {
      const endedGames: Array<GamesSliderWidgetGameViewModel> = this.games?.filter((game: GamesSliderWidgetGameViewModel) => game.isEnded && game.hasScore);
      const lastEndedGame: GamesSliderWidgetGameViewModel = endedGames?.last();
      const lastEndedGameIndex: Number = lastEndedGame ? this.games?.findIndex((game: GamesSliderWidgetGameViewModel) => game.id === lastEndedGame.id) : 0;

      initialIndex = lastEndedGameIndex;
    } else {
      const liveAndScheduled: Array<GamesSliderWidgetGameViewModel> = this.games?.filter((game: GamesSliderWidgetGameViewModel) => !game.isEnded);
      const firstLiveAndScheduled: GamesSliderWidgetGameViewModel = liveAndScheduled?.first();
      const firstLiveAndScheduledIndex: Number = firstLiveAndScheduled ? this.games?.findIndex((game: GamesSliderWidgetGameViewModel) => game.id === firstLiveAndScheduled.id) : this.games?.length - 1;

      initialIndex = firstLiveAndScheduledIndex;
    }

    return initialIndex;
  }

  @computed get hasOdds(): Boolean {
    const showOdds: Boolean = this.appState.settings.bootstrapSettings.showOdds;
    const hasOdds: Boolean = showOdds && this.games?.filter(game => game.odds).length > 0;

    return hasOdds;
  }

  @computed get sponsorshipBookmaker(): BookmakerViewModel {
    const bookmakerDomainModel: BookmakerDomainModel = this.dataSource?.bookmakers?.first();
    const bookmakerViewModel: BookmakerViewModel = bookmakerDomainModel && new BookmakerViewModel(bookmakerDomainModel);

    return bookmakerViewModel;
  }
}
